import ISPyB from '../config/config.js';
import {
  LOAD_CONFIGURATION 
} from '../constants/ActionTypes';


export function loadConfigurationBySite(siteName) { 
  return function (dispatch) { 
        dispatch({ type : LOAD_CONFIGURATION, payload : ISPyB.sites[0]});             
  }
}

export function loadConfiguration() {   
  return function (dispatch) { 
      dispatch({ type : LOAD_CONFIGURATION, payload : ISPyB.sites}); 
          
  }
}




// WEBPACK FOOTER //
// ./src/actions/configuration.js